import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, HostListener } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
// @ts-ignore
import { LucideAngularModule, Lock, User, LogIn, AlertCircle, Loader2, Eye, EyeOff, ChevronRight } from 'lucide-angular';

// @ts-ignore
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  loading = false;
  error = '';
  showPassword = false;
  manterLogado = true;
  camposObrigatoriosPulse = false;
  availableCompanies: any[] = [];
  showCompanySelection = false;
  isMobile = window.innerWidth <= 1024;
  capsLockAtivado: boolean = false;

  // Icons from Lucide
  readonly Lock = Lock;
  readonly User = User;
  readonly LogIn = LogIn;
  readonly AlertCircle = AlertCircle;
  readonly Loader2 = Loader2;
  readonly Eye = Eye;
  readonly EyeOff = EyeOff;
  readonly ChevronRight = ChevronRight;

  COMPANY_COLORS: any = {
    1: { bg: '#fafafa', border: '#121212' },
    2: { bg: '#fdeaea', border: '#d98d8b' },
    3: { bg: '#fef7ef', border: '#e8c4a0' },
    4: { bg: '#fef7ef', border: '#fcd4b4' },
    5: { bg: '#fff8e6', border: '#f5a623' },
    6: { bg: '#f5f5f5', border: '#a6a6a6' },
    7: { bg: '#f0f6fb', border: '#b0c8e5' },
    8: { bg: '#f3f9f0', border: '#8bc34a' },
    9: { bg: '#f5f9ed', border: '#c0d693' },
    10: { bg: '#f6f9fc', border: '#d6e3f2' },
    11: { bg: '#eef4fa', border: '#6185b1' },
    12: { bg: '#eef4fa', border: '#6185b1' },
    13: { bg: '#f4f1f8', border: '#ae99c7' },
    14: { bg: '#fdf3eb', border: '#b96927' },
    15: { bg: '#f2f8fa', border: '#aedce8' },
    16: { bg: '#fafafa', border: '#d9d9d9' },
    17: { bg: '#fdf3eb', border: '#b96927' },
    18: { bg: '#f9f7fb', border: '#e2daec' },
    19: { bg: '#faf9f4', border: '#d6d1b6' },
    20: { bg: '#f3f6fa', border: '#c3d2e5' }
  };

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.checkMobile();
    const authExpiredMessage = sessionStorage.getItem('authExpiredMessage');

    if (authExpiredMessage) {
      this.error = authExpiredMessage;
      sessionStorage.removeItem('authExpiredMessage');
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.checkMobile();
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 1024;
  }

  getCompanyStyle(id: number) {
    return this.COMPANY_COLORS[id] || { bg: '#f1f5f9', border: '#cbd5e1' };
  }

  cleanCompanyName(name: string) {
    if (!name) return "";
    return name
      .replace(/GLOBAL PARTS LTDA - /gi, '')
      .replace(/GLOBAL PARTS - /gi, '')
      .trim();
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  get loginPodeEntrar(): boolean {
    return !!this.username.trim() && !!this.password.trim();
  }

  hideCompanySelection() {
    this.showCompanySelection = false;
  }

  async handleLogin() {
    if (!this.loginPodeEntrar || this.loading) {
      this.error = 'Informe usuário e senha para entrar.';
      this.camposObrigatoriosPulse = true;
      setTimeout(() => {
        this.camposObrigatoriosPulse = false;
      }, 500);
      return;
    }

    this.loading = true;
    this.error = '';

    try {
      const adminResult = await this.authService.loginLocalAdmin(this.username, this.password);
      if (adminResult.success) {
        sessionStorage.setItem('isAdminAuthenticated', 'true');
        this.router.navigate(['/home']);
        return;
      }

      const apiLoginResult = await this.authService.loginRemoteApi(this.username, this.password, this.manterLogado);
      const storage = this.manterLogado ? localStorage : sessionStorage;

      if (apiLoginResult.authenticated) {
        const companies = await this.authService.fetchAllCompanies();

        if (companies.length > 1) {
          this.availableCompanies = companies;
          this.showCompanySelection = true;
          storage.setItem('userName', apiLoginResult.usuarioInfo?.usuarioNome || this.username.toUpperCase());
          storage.setItem('userGroup', apiLoginResult.usuarioInfo?.grupoNome || '');
          this.loading = false;
          return;
        } else if (companies.length === 1) {
          storage.setItem('activeCompanyId', companies[0].id.toString());
          storage.setItem('activeCompanyName', companies[0].nome);
        }
      }

      if (apiLoginResult.usuarioInfo) {
        storage.setItem('userName', apiLoginResult.usuarioInfo.usuarioNome || this.username.toUpperCase());
        storage.setItem('userGroup', apiLoginResult.usuarioInfo.grupoNome || '');
        storage.setItem('userId', apiLoginResult.usuarioInfo.usuarioId || '');
      } else {
        storage.setItem('userName', this.username.toUpperCase());
        storage.setItem('userGroup', '');
        storage.setItem('userId', '');
      }

      storage.setItem('isAdminAuthenticated', 'false');
      storage.setItem('isUserAuthenticated', 'true');
      this.router.navigate(['/home']);

    } catch (err: any) {
      this.error = this.authService.authErrorMessage(err);
    } finally {
      if (!this.showCompanySelection) {
        this.loading = false;
      }
    }
  }

  selectCompany(company: any) {
    const storage = this.manterLogado ? localStorage : sessionStorage;
    storage.setItem('activeCompanyId', company.id.toString());
    storage.setItem('activeCompanyName', company.nome);
    storage.setItem('isAdminAuthenticated', 'false');
    storage.setItem('isUserAuthenticated', 'true');
    this.router.navigate(['/home']);
  }

  verificarCapsLock(event: KeyboardEvent): void {
    if (event && typeof event.getModifierState === 'function') {
      this.capsLockAtivado = event.getModifierState('CapsLock');
    }
  }
}
